module.exports = __webpack_public_path__ + "img/tu06.12c8025c.png";